<div class="cipx-form-container w-full">
  <form [formGroup]="cancellationForm" class="cancellation-form">
    <cipx-scrollable-content [removeOverflowOnMobile]="true" [noPadding]="false">
      <div class="flex flex-col gap-6">
        <!-- Bond Summary Box -->
        <div class="p-4 rounded-lg bg-brandOrange-100 dark:bg-blue-900 border border-brandOrange dark:border-blue-800">
          <div class="flex flex-col">
            <span class="text-lg font-bold dark:text-blue-100">
              {{ bondAmount | currency }} {{ item?.quote_request_bond?.state_abbreviation }} {{ bondName }}
            </span>
            <span class="text-md font-medium dark:text-blue-200">
              {{ principalName }}
            </span>
            <span class="text-sm dark:text-blue-300 mt-1">
              Current expiration: {{ expirationDate | date: 'shortDate' }}
            </span>
          </div>
        </div>

        <!-- First Instructions -->
        <div class="text-md text-gray-700 dark:text-gray-300">
          Please explain why you are requesting to cancel this bond. Please include all relevant dates.
        </div>

        <!-- Cancellation Explanation -->
        <div class="flex flex-col">
          <tiny-editor [editorOptions]="{ min_height: 300 }" controlName="explanation" editorType="basic"></tiny-editor>
          <mat-error
            *ngIf="
              cancellationForm.get('explanation').dirty && cancellationForm.get('explanation').hasError('required')
            "
            class="mt-1">
            Explanation is required.
          </mat-error>
        </div>

        <!-- Second Instructions -->
        <div class="text-md text-gray-700 dark:text-gray-300">
          Please attach all relevant documents from the court or obligee.
        </div>

        <!-- Uploader -->
        <div class="mb-2 pb-2">
          <button
            mat-raised-button
            class="flex items-center mt-4"
            [disabled]="isSubmitting"
            (click)="openFileUploader()">
            <mat-icon>upload</mat-icon>
            <span class="ml-2 mr-1">Attach Files</span>
          </button>
        </div>

        <div class="mb-2 pb-2" *ngIf="queuedFiles?.length > 0">
          <span class="my-2 font-semibold">Selected files</span>
          <div class="flex flex-col gap-2 justify-start w-full overflow-x-auto">
            <div *ngFor="let file of queuedFiles; let i = index">
              <div class="flex flex-row items-center">
                <button mat-icon-button color="warn" (click)="deleteFile(i)">
                  <mat-icon>delete</mat-icon>
                </button>
                <div class="flex flex-col hover:bg-slate-50 hover:dark:bg-slate-700">
                  <p class="truncate text-xs uppercase text-gray-500">Documentation</p>
                  <p class="truncate max-w-[150px] md:max-w-[600px]">
                    {{ file.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </cipx-scrollable-content>

    <div class="acknowledgment">
      <mat-checkbox formControlName="acknowledgment" color="primary" class="acknowledgment-checkbox">
        <span class="text-sm leading-relaxed">
          By checking this box and proceeding to request the cancellation, I submit that I have the authority to request
          this bond cancellation for the principal. I further recognize that the authority and ultimate decision for
          cancellation, cancellation date, and potential premium refund lies with the surety and I understand that
          certain bonds are not cancellable and most bonds are considered fully-earned-premium if cancelled within the
          first term.
        </span>
      </mat-checkbox>
      <mat-error
        *ngIf="
          cancellationForm.get('acknowledgment').dirty && cancellationForm.get('acknowledgment').hasError('required')
        "
        class="mt-1">
        You must acknowledge the terms before submitting.
      </mat-error>
    </div>
  </form>
</div>
